import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { LuDownload } from "react-icons/lu"
import { RiFileExcel2Fill } from "react-icons/ri"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const postData = async (newData: FormData) => {
  const response = await api.post("/master/jurusan-sekolah/import", newData)
  return response.data
}

export default function FormImport({ closeModal }: { closeModal: () => void }) {
  const [file, setFile] = useState<File | null>(null)

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: postData,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listJurusanSekolah"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData()
    if (file) formData.append("file", file)

    mutate(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader
        title="Import Data Jurusan Sekolah"
        icon={<RiFileExcel2Fill />}
      />

      <div>
        <Label>Format Excel</Label>
        <div>
          <Button
            type="button"
            className="w-full flex items-center gap-3"
            variant={"outline"}
            onClick={() => {
              window.open("/format/format-import-jurusan-sekolah.xlsx")
            }}
          >
            <LuDownload /> Unduh Format Import
          </Button>
        </div>
      </div>
      <div>
        <Label>File Excel</Label>
        <Input
          required
          type="file"
          onChange={(event) => {
            const files = event.target.files
            if (files && files[0]) {
              setFile(files[0])
            }
          }}
        />
      </div>

      <Button className="mt-3 flex items-center gap-3" disabled={isPending}>
        {isPending ? (
          <>
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
            Processing...
          </>
        ) : (
          "Simpan"
        )}
      </Button>
    </form>
  )
}
